import React, { useState, useEffect } from 'react';
import { Container, Spinner, Alert, Button, Row, Col, ButtonGroup, Modal } from 'react-bootstrap';
import { useTheme } from '../../ThemeContext';
import SalesFeed from '../SalesFeed';
import { Link } from 'react-router-dom';
import { BsInfoCircle, BsArrowLeft, BsTelegram } from 'react-icons/bs';
const YesterdaySales = ({ closeModals }) => {
    useEffect(() => {
        closeModals();
    }, [closeModals]);

    const { theme } = useTheme();
    const [salesData, setSalesData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedPeriod, setSelectedPeriod] = useState(1);
    const [showInfo, setShowInfo] = useState(false);

    const fetchSales = async (days) => {
        try {
            setLoading(true);
            const response = await fetch(`https://pandoras-box.salew-bot.ru/get_yesterday_sales?days=${days}`);
            const data = await response.json();

            if (data.status && data.data_sale) {
                setSalesData(data.data_sale);
            } else {
                setError('Не удалось загрузить данные о продажах');
            }
        } catch (err) {
            setError('Ошибка подключения к серверу');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSales(selectedPeriod);
    }, [selectedPeriod]);


    return (
        <>
            <style>{`
.sb-header{position:sticky;top:0;z-index:10;display:flex;align-items:center;justify-content:space-between;padding:14px 22px;border-bottom:1px solid var(--sb-border)}
        .sb-light .sb-header{background:rgba(255,255,255,.9);backdrop-filter:blur(8px)}
        .sb-dark .sb-header{background:rgba(0,0,0,.35);backdrop-filter:blur(8px)}
        .sb-logo{display:flex;align-items:center;gap:10px;text-decoration:none;color:inherit;font-weight:800;letter-spacing:.2px;font-size:18px}
        .sb-logo-img{width:36px;height:36px;border-radius:8px;background:linear-gradient(135deg,var(--sb-accent),var(--sb-accent-2));flex:0 0 36px}
        @media (max-width:768px){
          .sb-header{padding:12px 16px}
          .sb-logo span{font-size:16px}
          }
          

      `}</style>
            <header className="sb-header">
                <Link className="sb-logo" to="/">
                    <img className="sb-logo-img" src="android-icon-36x36.png" alt="Salew Bot" width={36} height={36} />
                    <span>Salew Bot</span>
                </Link>



                {/* Центральная часть - заголовок */}
                <div className="d-flex align-items-center gap-2">
                    <h1 className="fs-5 fw-bold mb-0">🔥 Подборка скидок</h1>
                    <Button
                        variant="link"
                        className="p-0 text-reset"
                        onClick={() => setShowInfo(true)}
                    >
                        <BsInfoCircle className="fs-5" />
                    </Button>
                </div>

            </header>

            {/* Кнопки периода */}
            <div className="content-wrapper">
                {/* Кнопки периода */}
                <div className="period-selector">
                    <ButtonGroup className="period-buttons shadow-sm">
                        <Button
                            variant={
                                selectedPeriod === 1
                                    ? 'primary'
                                    : theme === 'dark'
                                        ? 'outline-light'
                                        : 'outline-secondary'
                            }
                            onClick={() => setSelectedPeriod(1)}
                            className="text-nowrap fw-semibold"
                        >
                            За вчера
                        </Button>
                        <Button
                            variant={
                                selectedPeriod === 7
                                    ? 'primary'
                                    : theme === 'dark'
                                        ? 'outline-light'
                                        : 'outline-secondary'
                            }
                            onClick={() => setSelectedPeriod(7)}
                            className="text-nowrap fw-semibold"
                        >
                            За неделю
                        </Button>
                    </ButtonGroup>
                </div>

                {/* Контент */}
                <div style={{ marginLeft: '-10px' }}>
                    {loading ? (
                        <div className="loading-spinner">
                            <Spinner
                                animation="border"
                                variant={theme === 'dark' ? 'light' : 'dark'}
                            />
                        </div>
                    ) : error ? (
                        <Alert variant="danger" className="error-alert">
                            {error}
                        </Alert>
                    ) : (
                        <SalesFeed sales={salesData} type="yesterday" />
                    )}
                </div>
            </div>

            {/* Модальное окно с описанием */}
            <Modal show={showInfo} onHide={() => setShowInfo(false)} centered className={theme === 'dark' ? 'text-white modal-dark' : 'text-dark modal-light'}>
                <Modal.Header closeButton className={
                    theme === 'dark'
                        ? 'border-bottom border-secondary bg-dark text-white'
                        : 'border-bottom border-secondary bg-light text-black'
                }
                    style={{
                        background:
                            theme === 'dark'
                                ? 'linear-gradient(135deg, #2a2a2a, #1e1e1e)'
                                : 'linear-gradient(135deg, #fff, #f8f9fa)',
                        padding: '12px',
                        borderTopLeftRadius: '8px',
                        borderTopRightRadius: '8px',
                    }}>
                    <Modal.Title style={{ fontWeight: 'bold', fontSize: '1.1rem', textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>Как формируется подборка</Modal.Title>
                </Modal.Header>
                <Modal.Body className={theme === 'dark' ? 'bg-dark text-white' : 'text-black bg-light'}
                    style={{
                        padding: '12px',
                        background:
                            theme === 'dark'
                                ? 'linear-gradient(135deg, #2a2a2a, #1e1e1e)'
                                : 'linear-gradient(135deg, #fff, #f8f9fa)',
                        borderRadius: '0',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                        color: theme === 'dark' ? '#fff' : '#333',
                        fontSize: '1rem',
                        lineHeight: '1.6',
                    }}>
                    <p className="mb-2">
                        В подборку попадают&nbsp;товары с остатком&nbsp;≥&nbsp;5&nbsp;шт. и
                        максимальным выкупом по многопараметрическому алгоритму
                        (учитываются&nbsp;продажи, категории, размер&nbsp;скидки и&nbsp;др.).
                    </p>
                    <p className="fst-italic mb-0 opacity-75">
                        «Вишенки» с остатком&nbsp;≤&nbsp;5&nbsp;шт. и&nbsp;другие жирные скидки
                        остаются в общей ленте — они часто ещё выгоднее, но автоматике их
                        сложнее оценить, поэтому в подборку попадает не всё.
                    </p>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default YesterdaySales;